import { Routes } from '@angular/router';
import { routes as mainRoutes } from '../../../../src/app/main.routes';

export const routes: Routes = mainRoutes;
